import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInfographic$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfographic extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1aa9ce8672ffbe64ed9c954dd3deba06acd67921', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '55c15c4f964cd9cac12b8704c4e0e5666f36aab0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b2fa2dcd86eb4f337c9231a166598afb7a28adeb', d: "M12 2a8 8 0 0 1 8 8h-7.5a.5.5 0 0 1-.5-.5z", fill: "currentColor" }), h("path", { key: 'c13cea64c95c982781c509d287aa2d49f250e15f', d: "M10 20a8 8 0 0 0 8-8h-7.5a.5.5 0 0 1-.5-.5V4a8 8 0 1 0 0 16", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-infographic", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-infographic"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-infographic":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfographic$1);
            }
            break;
    } });
}

const CosmosIconInfographic = CosmosIconInfographic$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfographic, defineCustomElement };
